'use client'
import Page from '~/containers/Checkout/Register/Register';

export default Page;
